// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HomePage_wrapper__2x5v_"};